import './NotFoundPage.scss';

export default function NotFoundPage(): JSX.Element {
  return <div className="NotFoundPage">404 Not found</div>;
}
